import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import { CHORD } from '../constants';

export default function LoginPage() {
  const [email, setEmail]     = useState('');
  const [pass, setPass]       = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault(); setError(''); setLoading(true);
    try { await login(email, pass); navigate('/'); }
    catch(err) { setError(err.message); }
    finally { setLoading(false); }
  }

  const inp = {
    width:'100%', background:'rgba(245,235,221,0.06)',
    border:`0.5px solid rgba(245,235,221,0.15)`,
    borderRadius:8, padding:'11px 14px', fontSize:14,
    color: CHORD.beige, outline:'none', fontFamily:'inherit',
    boxSizing:'border-box', marginBottom:'1rem',
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background: CHORD.softBlack, padding:'2rem' }}>

      {/* Decorative accent bar */}
      <div style={{ position:'fixed', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${CHORD.coral}, ${CHORD.orange}, ${CHORD.lime})` }} />

      <div style={{
        background: CHORD.bgCard, border:`0.5px solid ${CHORD.border}`,
        borderRadius:18, padding:'2.5rem', width:'100%', maxWidth:400,
        boxShadow:'0 24px 64px rgba(0,0,0,0.4)',
      }}>
        {/* Logo */}
        <div style={{ marginBottom:'2rem' }}>
          <div style={{ fontSize:26, fontWeight:700, letterSpacing:'-1px', color: CHORD.beige, lineHeight:1 }}>
            chord<span style={{color:CHORD.coral}}>.</span>
          </div>
          <div style={{ fontSize:11, color: CHORD.textFaint, letterSpacing:'2px', textTransform:'uppercase', marginTop:4 }}>
            Influencer Hub
          </div>
        </div>

        <div style={{ fontSize:22, fontWeight:600, marginBottom:4, color: CHORD.beige }}>Welcome back</div>
        <div style={{ fontSize:13, color: CHORD.textMuted, marginBottom:'2rem' }}>Sign in to manage your influencer roster</div>

        <form onSubmit={handleSubmit}>
          <label style={{ fontSize:12, color: CHORD.textMuted, marginBottom:6, display:'block', letterSpacing:'0.3px' }}>Email address</label>
          <input style={inp} type="email" placeholder="you@chord-agency.com" value={email} onChange={e=>setEmail(e.target.value)} required />

          <label style={{ fontSize:12, color: CHORD.textMuted, marginBottom:6, display:'block', letterSpacing:'0.3px' }}>Password</label>
          <input style={{...inp, marginBottom: error ? '0.5rem' : '1.25rem'}} type="password" placeholder="••••••••" value={pass} onChange={e=>setPass(e.target.value)} required />

          {error && <div style={{ fontSize:12, color: CHORD.coral, marginBottom:'1rem', padding:'8px 12px', background:`${CHORD.coral}15`, borderRadius:6, border:`0.5px solid ${CHORD.coral}40` }}>{error}</div>}

          <button type="submit" disabled={loading} style={{
            width:'100%', background: CHORD.coral, border:'none',
            borderRadius:8, padding:12, fontSize:14, fontWeight:700,
            color:'#fff', cursor:'pointer', fontFamily:'inherit',
            opacity: loading ? 0.6 : 1, letterSpacing:'0.3px',
          }}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
